<mat-dialog-content #fontResizerContent class="font-resizer-menu mat-elevation-z8">
  <div class="font-resizer-controls" data-automation-id="font-resizer-controls">
    <button
      data-automation-id="font-resizer-decrease-button"
      [attr.aria-label]="'font-resizer.decrease_size' | translate"
      class="btn btn-icon"
      [disabled]="decreaseDisabled$ | async"
      (click)="decrease()"
    >
      A
    </button>

    <mat-slider
      #ngSlider
      data-automation-id="font-resizer-slider"
      class="mhe-a11y rdrx-slider"
      [max]="max"
      [min]="min"
      step="1"
      [displayWith]="formatSliderLabel"
    >
      <input
        matSliderThumb
        #ngSliderThumb="matSliderThumb"
        [formControl]="sliderControl"
        [attr.min]="min"
        [attr.max]="max"
        [attr.aria-label]="'font-resizer.slider' | translate"
        data-automation-id="font-resizer-slider-thumb"
        (input)="fontsizeValueChanged({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value })"/>
    </mat-slider>

    <button
      data-automation-id="font-resizer-increase-button"
      [attr.aria-label]="'font-resizer.increase_size' | translate"
      class="btn btn-icon"
      [disabled]="increaseDisabled$ | async"
      (click)="increase()"
    >
      A
    </button>
  </div>
</mat-dialog-content>
